import { render } from "./EventEditor.vue?vue&type=template&id=4b310832&scoped=true"
import script from "./EventEditor.vue?vue&type=script&lang=js"
export * from "./EventEditor.vue?vue&type=script&lang=js"

import "./EventEditor.vue?vue&type=style&index=0&id=4b310832&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b310832"]])

export default __exports__